import axios from 'axios';
import { isEmpty } from 'lodash';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import { returnInitialStudy, exportFileTitle } from '../util/CommonUtils';
import { CORRCLUSTER_FEATUREID } from '../constants';

export const creatCACProject = ({
  base = [],
  columns = [],
  rows = [],
  study,
  weightTypes,
  viewMode,
  title,
}) => {
  return (dispatch, getState) => {
    const studyInfo =
      study === undefined
        ? returnInitialStudy(getState().study.studies, CORRCLUSTER_FEATUREID)
        : study;
    if (!isEmpty(studyInfo)) {
      dispatch({
        type: types.CREATE_CAC_NEW_PROJECT,
        base,
        columns,
        rows,
        study: studyInfo,
        weightTypes: weightTypes === undefined ? studyInfo.cw[0] : weightTypes,
        leftPanel: viewMode,
        title,
      });
    }
  };
};

export function getCACProjectDetails({
  userId,
  currentAccountId,
  base,
  columns,
  rows,
  study,
  title,
  passiveCols,
  passiveRows,
  weightTypes,
}) {
  if (base[0] && base[0].keyword === 'StudyUniverseKey') {
    base = [];
  }
  const rowsFilterData = [];
  const colsFilterData = [];
  if (rows) {
    rows.forEach((item, index) => {
      if (item.isShow === true) {
        rowsFilterData.push(rows[index]);
      }
    });
  }
  if (columns) {
    columns.forEach((item, index) => {
      if (item.isShow === true) {
        colsFilterData.push(columns[index]);
      }
    });
  }
  const crRequest = {
    products: [study.pn],
    weightType: weightTypes.wt,
    divisor: weightTypes.dv,
    baseList: base.map(item => item.keyword),
    baseHeaderList: base.map(item => item.originalTitle),
    colExpressionList: colsFilterData.map(col => col.keyword),
    // labels are editable, so can't use originalTitle (needs to be tested)
    // colHeaderList: colsFilterData.map(col => col.originalTitle),
    colHeaderList: colsFilterData.map(col => col.title),
    rowExpressionList: rowsFilterData.map(row => row.keyword),
    // rowHeaderList: rowsFilterData.map(row => row.originalTitle),
    rowHeaderList: rowsFilterData.map(row => row.title),
  };
  const url = `${urls.ROOT_URL}/correspondence/report/${userId}/${currentAccountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 501,
      data: {
        crRequest,
        passiveRows,
        passiveCols,
      },
    })
      .then(res => {
        const payload = res.status === 200 ? res.data.data : res.data;
        dispatch({
          type: types.ADD_CAC_PROJECT_DETAILS,
          payload,
          title,
        });
      })
      .catch(error => console.warn(error));
  };
}

function getCountourMapData(
  userId,
  currentAccountId,
  crRequest,
  passiveRows,
  passiveCols,
  clusterBy,
  title,
  maxCluster
) {
  const url = `${urls.ROOT_URL}/correspondence/cluster/contourmap/${userId}/${currentAccountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 501,
      data: {
        crRequest,
        passiveRows,
        passiveCols,
        clusterBy,
        maxCluster,
      },
    })
      .then(res => {
        const payload = res.status === 200 ? res.data.data : res.data;

        dispatch({
          type: types.CAC_ADD_PROJECT_CONTOUR_MAP,
          payload,
          title,
        });
      })
      .catch(error => console.warn(error));
  };
}

export function getCACProjectContourMap({
  userId,
  currentAccountId,
  base,
  columns,
  rows,
  study,
  title,
  passiveCols,
  passiveRows,
  clusterBy,
  weightTypes,
  clusterSegmentCount,
}) {
  if (base[0] && base[0].keyword === 'StudyUniverseKey') {
    base = [];
  }
  const rowsFilterData = [];
  const colsFilterData = [];
  if (rows) {
    rows.forEach((item, index) => {
      if (item.isShow === true) {
        rowsFilterData.push(rows[index]);
      }
    });
  }
  if (columns) {
    columns.forEach((item, index) => {
      if (item.isShow === true) {
        colsFilterData.push(columns[index]);
      }
    });
  }
  const crRequest = {
    products: [study.pn],
    weightType: weightTypes.wt,
    divisor: weightTypes.dv,
    baseList: base.map(item => item.keyword),
    baseHeaderList: base.map(item => item.originalTitle),
    colExpressionList: colsFilterData.map(col => col.keyword),
    // labels are editable, so can't use originalTitle (needs to be tested)
    // colHeaderList: colsFilterData.map(col => col.originalTitle),
    colHeaderList: colsFilterData.map(col => col.title),
    rowExpressionList: rowsFilterData.map(row => row.keyword),
    // rowHeaderList: rowsFilterData.map(row => row.originalTitle),
    rowHeaderList: rowsFilterData.map(row => row.title),
  };
  return getCountourMapData(
    userId,
    currentAccountId,
    crRequest,
    passiveRows,
    passiveCols,
    clusterBy,
    title,
    clusterSegmentCount
  );
}

export const handleViewSwitch = (activeView, activeProjectId) => ({
  type: types.CAC_HANDLE_VIEW_SWITCH,
  activeView,
  activeProjectId,
});

export const setCACProjectToActive = (selectedProjectId, activeProjectId) => ({
  type: types.SET_CAC_PROJECT_TO_ACTIVE,
  selectedProjectId,
  activeProjectId,
});

export const toggleCollapsibleDropdown = (keyType, activeProjectId) => ({
  type: types.TOGGLE_COLLAPSIBLE_DROPDOWN,
  keyType,
  activeProjectId,
});

export const setCacShowContributionScores = (
  activeProjectId,
  showContributionScores
) => ({
  type: types.CAC_SHOW_CONTRIBUITON_SCORES,
  activeProjectId,
  showContributionScores,
});

export const setCacCenterChart = (activeProjectId, centerChart) => ({
  type: types.CAC_SET_IS_CENTER_CHART,
  activeProjectId,
  centerChart,
});

export const setCacShowPassives = (activeProjectId, showPassive) => ({
  type: types.CAC_SET_SHOW_PASSIVES,
  activeProjectId,
  showPassive,
});

export const setCacIsAxisVisible = (activeProjectId, isAxisVisible) => ({
  type: types.CAC_SET_IS_AXIS_VISIBLE,
  activeProjectId,
  isAxisVisible,
});

export const setCacAreRowsVisible = (activeProjectId, areRowsVisible) => ({
  type: types.CAC_SET_ARE_ROWS_VISIBLE,
  activeProjectId,
  areRowsVisible,
});

export const setCacAreColsVisible = (activeProjectId, areColsVisible) => ({
  type: types.CAC_SET_ARE_COLS_VISIBLE,
  activeProjectId,
  areColsVisible,
});

export const setCacShowRowLongNames = (activeProjectId, showRowLongNames) => ({
  type: types.CAC_SHOW_ROW_LONG_NAMES,
  activeProjectId,
  showRowLongNames,
});
export const setCacShowColLongNames = (activeProjectId, showColLongNames) => ({
  type: types.CAC_SHOW_COL_LONG_NAMES,
  activeProjectId,
  showColLongNames,
});
export const setCacShowPassiveLongNames = (
  activeProjectId,
  showPassiveLongNames
) => ({
  type: types.CAC_SHOW_PASSIVE_LONG_NAMES,
  activeProjectId,
  showPassiveLongNames,
});

export const setCacChartView = (activeProjectId, chartView) => ({
  type: types.CAC_CHART_VIEW,
  activeProjectId,
  chartView,
});

export const setCacUpdatesNodes = (activeProjectId, updateNodes) => ({
  type: types.CAC_UPDATE_NODES,
  activeProjectId,
  updateNodes,
});

export const clearCacNodeLabelPositions = activeProjectId => ({
  type: types.CAC_CLEAR_LABEL_POSITIONS,
  activeProjectId,
});

export const updateCacNodeLabelPositions = (
  activeProjectId,
  nodeLabelPositions,
  isCenterChart,
  cView
) => ({
  type: types.CAC_NODE_LABEL_POSITIONS,
  activeProjectId,
  nodeLabelPositions,
  isCenterChart,
  cView,
});

export const setCacNodeColors = (activeProjectId, nodeColors) => ({
  type: types.CAC_NODE_COLORS,
  activeProjectId,
  nodeColors,
});

export const setCacProjectSavedFlag = (activeProjectId, isProjectSaved) => ({
  type: types.CAC_IS_PROJECT_SAVED,
  activeProjectId,
  isProjectSaved,
});

export const addToPassive = (gridType, activeProjectId, index) => ({
  type: types.ADD_TO_PASSIVE,
  gridType,
  activeProjectId,
  index,
});

export const editProjectTabName = (updatedObjectProps, activeProjectId) => ({
  type: types.EDIT_PROJECT_TAB_NAME,
  updatedObjectProps,
  activeProjectId,
});

export const editRowColTitle = (
  activeProjectId,
  newTitle,
  nodeType,
  nodeIndex
) => ({
  type: types.CAC_EDIT_ROW_COL_TITLE,
  activeProjectId,
  newTitle,
  nodeIndex,
  nodeType,
});

export const restoreRowColTitle = (activeProjectId, nodeType, nodeIndex) => ({
  type: types.CAC_RESTORE_ROW_COL_TITLE,
  activeProjectId,
  nodeIndex,
  nodeType,
});

export const saveCACActiveProject = ({
  userId,
  currentAccountId,
  title,
  activeProjectId,
  pid,
  isRenamed,
  newProject,
  closeProject,
  detailsToSave,
}) => {
  return dispatch =>
    new Promise(resolve => {
      const payload = {
        pid,
        title: title.trim(),
        details: detailsToSave,
      };
      const url = `${urls.ROOT_URL}/correspondence/projects/${userId}/${currentAccountId}`;
      axios({
        url,
        method: 'post',
        headers: {
          Accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        validateStatus: status => status >= 200 && status < 202,
        data: [payload],
      })
        .then(response => {
          if (response.status === 200) {
            if (response.data && response.data.length > 0) {
              const projectResponse = response.data[0];
              if (projectResponse.saved) {
                if (isRenamed) {
                  if (newProject) {
                    dispatch({
                      type: types.CREATE_CAC_NEW_PROJECT_FROM_SAVE,
                      details: detailsToSave,
                      title,
                      pid: projectResponse.pid,
                      activeProjectId,
                    });
                  } else {
                    dispatch({
                      type: types.UPDATE_NEW_PROJECT_PID,
                      payload: {
                        activeProjectId,
                        pid: projectResponse.pid,
                        title: projectResponse.title,
                        originalTitle: projectResponse.title,
                      },
                    });
                  }
                } else {
                  dispatch({
                    type: types.UPDATE_NEW_PROJECT_PID,
                    payload: {
                      activeProjectId,
                      pid: projectResponse.pid,
                      originalTitle: projectResponse.title,
                    },
                  });
                }
                resolve({ status: true, closeProject });
              } else if (projectResponse.duplicateTitle) {
                if (isRenamed) {
                  dispatch({
                    type: types.UPDATE_TEMP_PROJECT_TITLE,
                    payload: { activeProjectId, title: projectResponse.title },
                  });
                  resolve({ status: false, message: 'duplicate' });
                } else {
                  resolve({ status: false, message: 'duplicate' });
                }
              }
            }
          }
        })
        .then(error => {
          if (error && error.status === 400) {
            // code for opening the popup
            resolve(false);
          }
        });
    });
};

export const removeTempTitle = activeProjectId => ({
  type: types.REMOVE_ACTIVE_PROJECT_TEMP_TITLE,
  activeProjectId,
});

export const showSavedCacProjects = (uid, accountId) =>
  new Promise(resolve => {
    const url = `${urls.ROOT_URL}/correspondence/projects/${uid}/${accountId}`;
    axios({
      url,
      method: 'get',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
    })
      .then(response => {
        if (response.status === 200) {
          resolve(response.data.data);
        }
      })
      .catch(response => console.warn(response));
  });

export function openSelectedProjects(
  userId,
  currentAccountId,
  selectedIds,
  selectedProjectId
) {
  const url = `${urls.ROOT_URL}/correspondence/projects/load/${userId}/${currentAccountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: selectedIds,
    })
      .then(res =>
        dispatch({
          type: types.ADD_OPENED_PROJECTS_DATA,
          payload: res.data.data,
          selectedProjectId,
        })
      )
      .catch(error => console.warn(error));
  };
}

export const duplicateProject = () => ({
  type: types.DUPLICATE_PROJECT,
});

export const cacCloseProjectThunk = initialStudy => ({
  type: types.CAC_CLOSE_PROJECT,
  initialStudy,
});

export const cacCloseProject = () => {
  return (dispatch, getState) => {
    const initialStudy = returnInitialStudy(
      getState().study.studies,
      CORRCLUSTER_FEATUREID
    );
    dispatch(cacCloseProjectThunk(initialStudy));
  };
};

export const showHideDataPoint = (gridType, activeProjectId, index) => ({
  type: types.SHOW_HIDE_DATAPOINT,
  gridType,
  activeProjectId,
  index,
});

export const updateCaCProjectStudy = (
  activeProjectId,
  selectedStudy,
  updatedWeightType
) => ({
  type: types.CAC_UPDATE_PROJECT_STUDY,
  selectedStudy,
  updatedWeightType,
  activeProjectId,
});

export const updateCaCProjectWeightType = (
  activeProjectId,
  updatedWeightType
) => ({
  type: types.CAC_UPDATE_PROJECT_WEIGHT_TYPES,
  updatedWeightType,
  activeProjectId,
});

export const cacUpdateSwitchPanel = () => ({
  type: types.CAC_CORR_SWITCH_DATA,
});

export const cacUpdateClusterSwitchPanel = () => ({
  type: types.CAC_CLUSTER_SWITCH_DATA,
});

export const handleTabSelect = tabIndex => ({
  type: types.CAC_HANDLE_TAB_SELECT,
  tabIndex,
});

export const updateClusterSegmentCount = (activeProjectId, segmentCount) => ({
  type: types.CAC_CLUST_UPDATE_SEGMENT_COUNT,
  activeProjectId,
  segmentCount,
});

export const setSelectedCluster = (
  activeProjectId,
  selectedCluster,
  segmentCount
) => ({
  type: types.CAC_CLUST_SELECTED_CLUSTER,
  activeProjectId,
  selectedCluster,
  segmentCount,
});

export function getClusterProjectDetails({
  userId,
  currentAccountId,
  base,
  columns,
  rows,
  study,
  title,
  passiveCols,
  passiveRows,
  clusterBy,
  weightTypes,
  clusterSegmentCount,
}) {
  if (base[0] && base[0].keyword === 'StudyUniverseKey') {
    base = [];
  }
  const rowsFilterData = [];
  const colsFilterData = [];
  if (rows) {
    rows.forEach((item, index) => {
      if (item.isShow === true) {
        rowsFilterData.push(rows[index]);
      }
    });
  }
  if (columns) {
    columns.forEach((item, index) => {
      if (item.isShow === true) {
        colsFilterData.push(columns[index]);
      }
    });
  }
  const crRequest = {
    products: [study.pn],
    weightType: weightTypes.wt,
    divisor: weightTypes.dv,
    baseList: base.map(item => item.keyword),
    baseHeaderList: base.map(item => item.originalTitle),
    colExpressionList: colsFilterData.map(col => col.keyword),
    // labels are editable, so can't use originalTitle (needs to be tested)
    // colHeaderList: colsFilterData.map(col => col.originalTitle),
    colHeaderList: colsFilterData.map(col => col.title),
    rowExpressionList: rowsFilterData.map(row => row.keyword),
    // rowHeaderList: rowsFilterData.map(row => row.originalTitle),
    rowHeaderList: rowsFilterData.map(row => row.title),
  };
  const url = `${urls.ROOT_URL}/correspondence/cluster/report/${userId}/${currentAccountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 501,
      data: {
        crRequest,
        passiveRows,
        passiveCols,
        clusterBy,
      },
    })
      .then(res => {
        const payload = res.status === 200 ? res.data.data : res.data;
        const getMC = () => {
          const optSol = payload.solutions.find(x => x.optimal);
          return optSol ? optSol.segmentCount : 0;
        };

        const maxCluster =
          clusterSegmentCount !== 0
            ? clusterSegmentCount
            : payload.solutions
            ? getMC()
            : 0;

        dispatch({
          type: types.CLUSTER_PROJECT_DETAILS,
          payload,
          title,
        });
        dispatch(
          getCACProjectContourMap({
            userId,
            currentAccountId,
            base,
            columns,
            rows,
            study,
            title,
            passiveCols,
            passiveRows,
            clusterBy,
            weightTypes,
            clusterSegmentCount: maxCluster,
          })
        );
        // getCountourMapData(
        //   userId,
        //   currentAccountId,
        //   crRequest,
        //   passiveRows,
        //   passiveCols,
        //   clusterBy,
        //   title,
        //   maxCluster
        // );
      })
      .catch(error => console.warn(error));
  };
}

export const handleClusterBySwitch = val => ({
  type: types.HANDLE_CLUSTER_BY_SWITCH,
  val,
});

export const handleCorrTabSelect = payload => ({
  type: types.CORR_TABLE_TAB_SELECT,
  payload,
});

export const updateSortOrder = payload => ({
  type: types.CORR_TABLE_SORT_DATA,
  payload,
});

export const editClusterSegmentName = (newSegmentName, index) => ({
  type: types.EDIT_CLUSTER_SEGMENT_NAME,
  newSegmentName,
  index,
});

export const saveClusterSolution = ({
  userId,
  currentAccountId,
  solutionName,
  segmentNames,
  base,
  columns,
  rows,
  study,
  passiveCols,
  passiveRows,
  clusterBy,
  weightTypes,
  clusterSegmentCount,
}) => {
  return () =>
    new Promise(resolve => {
      if (base[0] && base[0].keyword === 'StudyUniverseKey') {
        base = [];
      }
      const rowsFilterData = [];
      const colsFilterData = [];
      if (rows) {
        rows.forEach((item, index) => {
          if (item.isShow === true) {
            rowsFilterData.push(rows[index]);
          }
        });
      }
      if (columns) {
        columns.forEach((item, index) => {
          if (item.isShow === true) {
            colsFilterData.push(columns[index]);
          }
        });
      }
      const crRequest = {
        products: [study.pn],
        weightType: weightTypes.wt,
        divisor: weightTypes.dv,
        baseList: base.map(item => item.keyword),
        baseHeaderList: base.map(item => item.originalTitle),
        colExpressionList: colsFilterData.map(col => col.keyword),
        // labels are editable, so can't use originalTitle (needs to be tested)
        // colHeaderList: colsFilterData.map(col => col.originalTitle),
        colHeaderList: colsFilterData.map(col => col.title),
        rowExpressionList: rowsFilterData.map(row => row.keyword),
        // rowHeaderList: rowsFilterData.map(row => row.originalTitle),
        rowHeaderList: rowsFilterData.map(row => row.title),
      };
      const url = `${urls.ROOT_URL}/correspondence/cluster/${userId}/${currentAccountId}`;
      axios({
        url,
        method: 'post',
        headers: {
          Accept: 'application/json;charset=UTF-8',
        },
        withCredentials: true,
        responseType: 'json',
        validateStatus: status => status >= 200 && status < 401,
        data: {
          crRequest,
          passiveRows,
          passiveCols,
          clusterBy,
          defName: solutionName,
          segmentNames,
          maxCluster: clusterSegmentCount,
        },
      }).then(response => {
        if (response.status === 400) {
          resolve({ status: false });
        } else {
          resolve({ status: true });
        }
      });
    });
};

export function exportCACProject({
  userId,
  currentAccountId,
  base,
  columns,
  rows,
  study,
  title,
  passiveCols,
  passiveRows,
  clusterBy,
  weightTypes,
  chartViewName,
  selectedCluster,
}) {
  if (base[0] && base[0].keyword === 'StudyUniverseKey') {
    base = [];
  }
  const rowsFilterData = [];
  const colsFilterData = [];
  if (rows) {
    rows.forEach((item, index) => {
      if (item.isShow === true) {
        rowsFilterData.push(rows[index]);
      }
    });
  }
  if (columns) {
    columns.forEach((item, index) => {
      if (item.isShow === true) {
        colsFilterData.push(columns[index]);
      }
    });
  }

  const crRequest = {
    products: [study.pn],
    weightType: weightTypes.wt,
    divisor: weightTypes.dv,
    baseList: base.map(item => item.keyword),
    baseHeaderList: base.map(item => item.title),
    colExpressionList: colsFilterData.map(col => col.keyword),
    colHeaderList: colsFilterData.map(col => col.title),
    rowExpressionList: rowsFilterData.map(row => row.keyword),
    rowHeaderList: rowsFilterData.map(row => row.title),
  };
  const url = `${urls.ROOT_URL}/reports/export/cnc/${userId}/${currentAccountId}`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 501,
      data: {
        crRequest,
        passiveRows,
        passiveCols,
        clusterBy,
        selectedWeightName: weightTypes.wn,
        axesDisplay: chartViewName,
        selectedSolution: selectedCluster !== -1 ? selectedCluster + 1 : 0,
        // if there are no selectedCluster pass as zero
        title,
        fileName: exportFileTitle(`Correspondence and Cluster ${title}`),
      },
    })
      .then(response =>
        dispatch({
          type: types.EXPORT_CLUSTER_AND_CORRESPONDENCE,
          payload: response.data.data,
        })
      )
      .catch(error => console.warn(error));
  };
}
